import React, { lazy } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router';
import { CategoryDetailsPage } from '@betty/games/pages';
import AppLayout from './components/AppLayout/AppLayout';
import { RewardsPage } from '@betty/rewards/pages';
import { ShopPage } from '@betty/shop/pages';
import { JoinPage, RegistrationPage } from '@betty/registration/pages';

import './navigation';
import {
  InteracRedirectPage,
  WithdrawVerifyInteracEmailRedirectPage,
} from '@betty/wallet/pages';
import ProtectedRoutes from './components/ProtectedRoutes';
import {
  renderAccountRoutes,
  renderGamesRoutes,
  renderMiscRoutes,
  renderPromosRoutes,
  renderQuestsRoutes,
} from './routes';
import DynamicRoute from './routes/DynamicRoute';

const HomePage = lazy(() => import('./pages/HomePage/HomePage'));
const LandingPage = lazy(() => import('./pages/LandingPage/LandingPage'));
const CommunityJackpotRulesPage = lazy(
  () => import('@betty/community-jackpot/pages/CommunityJackpotRulesPage'),
);
const CommunityJackpotRoutePage = lazy(
  () => import('@betty/community-jackpot/pages/CommunityJackpotRoutePage'),
);

const routes = createRoutesFromElements(
  <Route path="/" element={<AppLayout />}>
    {renderMiscRoutes()}
    {renderGamesRoutes()}
    {renderAccountRoutes()}
    {renderPromosRoutes()}
    {renderQuestsRoutes()}
    <Route
      index
      element={
        <DynamicRoute
          AuthenticatedComponent={HomePage}
          AnonymousComponent={LandingPage}
        />
      }
    />
    <Route path="/register" element={<RegistrationPage />} />
    <Route path="/join/:referralCode" element={<JoinPage />} />
    <Route
      path="/verifyInteracEmail"
      element={<WithdrawVerifyInteracEmailRedirectPage />}
    />
    <Route element={<ProtectedRoutes />}>
      <Route path="/interac-redirect" element={<InteracRedirectPage />} />
      <Route path="/rewards" element={<RewardsPage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route
        path="/communityjackpotrules"
        Component={CommunityJackpotRulesPage}
      />
      <Route path="/communityJackpot" element={<CommunityJackpotRoutePage />} />
    </Route>
    <Route path=":categorySlug" element={<CategoryDetailsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Route>,
);

export default createBrowserRouter(routes);
